import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-property-actions',
  templateUrl: './property-actions.component.html',
  styleUrls: ['./property-actions.component.scss']
})
export class PropertyActionsComponent {
    @Output() onFavorite = new EventEmitter<void>();
    @Output() onShare = new EventEmitter<void>();

    toggleFavorite() {
        this.onFavorite.emit();
    }

    shareProperty() {
        this.onShare.emit();
    }

}
